module.exports = {
	en: require('./en.json'),
	ar: require('./ar.json'),
	es: require('./es.json'),
	br: require('./br.json'),
	cat: require('./cat.json'),
	fr: require('./fr.json'),
	nl: require('./nl.json'),
	de: require('./de.json'),
};
